var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"cm-documentation__content-list-numbered"},_vm._l((_vm.data.content),function(list){return _c('li',{key:list,domProps:{"innerHTML":_vm._s(list)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }